import { render, staticRenderFns } from "./Facturi.vue?vue&type=template&id=fd037782&scoped=true"
import script from "./Facturi.vue?vue&type=script&lang=js"
export * from "./Facturi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd037782",
  null
  
)

export default component.exports